import { Navigate, Outlet, useLocation } from "react-router-dom";

import { useUser } from "@/client/services/user";
import { addLocaleToPath, getLocaleFromPath } from "@/client/utils/url-locales";

export const AuthGuard = () => {
  const location = useLocation();
  const redirectTo = location.pathname + location.search;

  // Get locale from current URL to preserve it in login redirect
  const currentLocale = getLocaleFromPath(location.pathname);

  const { user, loading } = useUser();

  if (loading) return null;

  if (user) {
    return <Outlet />;
  }

  // Redirect to localized login page to preserve language preference
  const loginPath = currentLocale 
    ? addLocaleToPath("/auth/login", currentLocale) 
    : "/auth/login";
  
  return <Navigate replace to={`${loginPath}?redirect=${encodeURIComponent(redirectTo)}`} />;
};
